/**
 * Build Surprise Runtime web action URLs.
 * Priority: per-action SURPRISE_URL_* override, else SURPRISE_WEB_ACTIONS_BASE + path,
 * else same-origin /api/v1/web/<package>/<action> (aio dev proxy / hosted gateway, like Express /api).
 */
import { SURPRISE_ACTION_PATHS, SURPRISE_URL_ENV_KEYS } from './actionUrlMap.js'

/** Must match app.config.yaml runtimeManifest.packages key. */
const SURPRISE_IO_PACKAGE = 'prj-testkitchen'

function trimBase (base) {
  return String(base || '').trim().replace(/\/+$/, '')
}

function defaultActionsBase () {
  if (typeof window === 'undefined' || !window.location) return ''
  return `/api/v1/web/${SURPRISE_IO_PACKAGE}`
}

export function buildActionUrlsFromEnv () {
  const fromEnv = trimBase(process.env.SURPRISE_WEB_ACTIONS_BASE)
  const base = fromEnv || defaultActionsBase()
  const out = {}
  for (const key of Object.keys(SURPRISE_ACTION_PATHS)) {
    const envName = SURPRISE_URL_ENV_KEYS[key]
    const explicit = envName ? String(process.env[envName] || '').trim() : ''
    if (explicit) {
      out[key] = explicit
      continue
    }
    const segment = SURPRISE_ACTION_PATHS[key]
    out[key] = base && segment ? `${base}/${segment}` : ''
  }
  return out
}
